module.exports = __webpack_public_path__ + "static/media/matic.3cb96389.webp";